import { render } from "./ContactUsCMS.vue?vue&type=template&id=76c4c5ce"
import script from "../js/contact-us-cms?vue&type=script&lang=js"
export * from "../js/contact-us-cms?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/platinum-landscape/platinum-landscape-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__